import { render } from "./Ceremonie.vue?vue&type=template&id=5311b911&scoped=true"
import script from "./Ceremonie.vue?vue&type=script&lang=js"
export * from "./Ceremonie.vue?vue&type=script&lang=js"

import "./Ceremonie.vue?vue&type=style&index=0&id=5311b911&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5311b911"]])

export default __exports__